{
	"title": "Impressum",
	"backTitle": "Înapoi",
	"company": {
		"name": "HDigital GmbH",
		"address": {
			"street": "Berliner Strasse 6",
			"city": "69120 Heidelberg",
			"country": "Germania"
		},
		"contact": {
			"telephone": "Telefon: +49 6221 481-0",
			"telefax": "Telefax: +49 6221 481-13553",
			"email": "E-mail: info@heidelbergmaterials.com"
		},
		"legal": {
			"registeredOffice": "Sediul social al companiei: Heidelberg",
			"commercialRegister": "Registrul comerțului: Mannheim, HRB 741878",
			"managingDirectors": "Directori generali:",
			"directors": {
				"rene": "René Aldach",
				"roland": "Roland Sterr",
				"noman": "Noman Ahmed"
			}
		}
	}
}
